import React from 'react';
import { Alert } from '@mui/material';
import { BlockSettingsProps } from './types';

export const DefaultSettings: React.FC<BlockSettingsProps> = ({ kedo }) => (
    <Alert severity="info" sx={{ mt: 2 }}>{kedo.t('No additional settings required.')}</Alert>
);